export default __webpack_public_path__ + "static/media/MayDom2024.ea9167e3.png";